export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.llegoev.app";
export const APP_STORE_URL = "https://apps.apple.com/uy/app/llego/id1234567890";
export const CONTACT_EMAIL = "hola@llegoev.com";
